// extracted by mini-css-extract-plugin
export default {"container":"Orders_container__8WsNb","back__button":"Orders_back__button__UkBLe"};